import { App, Button, Col, Form, Input, Modal, Row } from "antd";
import { FC, useEffect, useState } from "react";
import { useUpdateUser } from "services/user";
import { Address, CreateInput } from "src/lib/address-autocomplete";
import { IUserDetailForm } from "types/user";
const InputThaiAddress = CreateInput();

interface IUserDetailModal {
  isOpen: boolean;
  onClose: () => void;
  data?: IUserDetailForm;
}
const UserDetailModal: FC<IUserDetailModal> = ({ isOpen, data, onClose }) => {
  const [form] = Form.useForm();
  const { notification } = App.useApp();

  const { updateUserAsync, isPending } = useUpdateUser();

  const [address, setAddress] = useState<Address>({
    district: "", // ตำบล tambol
    amphoe: "", // อำเภอ amphoe
    province: "", // จังหวัด changwat
    zipcode: "", // รหัสไปรษณีย์ postal code
  });

  const handleChange = (scope: string) => (value: string) => {
    setAddress((oldAddr: Address) => ({
      ...oldAddr,
      [scope]: value,
    }));
  };

  const handleSelect = (address: Address) => {
    form.setFieldsValue({
      province: address.province,
      district: address.amphoe,
      subdistrict: address.district,
      postCode: address.zipcode,
    });
    setAddress(address);
  };

  useEffect(() => {
    if (isOpen) {
      if (data) {
        console.log("initial value", data);
        form.setFieldsValue({
          address: data.address,
          phoneNumber: data.phoneNumber,
          province: data.province,
          district: data.district,
          subdistrict: data.subdistrict,
          postCode: data.postCode,
          lineId: data.lineId,
        });
      } else {
        form.resetFields();
      }
    }
  }, [isOpen, data]);

  const handleOnSubmitForm = async () => {
    const formValue = form.getFieldsValue();
    // update address
    if (data) {
      await updateUserAsync({ id: data.id, ...formValue });
      notification.success({
        message: "แก้ไขที่อยู่สำเร็จ",
        // description: "",
        placement: "topRight",
      });
    }
    onClose();
  };

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      onClose={onClose}
      width={700}
      footer={() => {
        return (
          <div>
            <div className="justify-center flex gap-4 mt-8">
              <Button key="back" onClick={onClose} className="px-4 md:px-14">
                ยกเลิก
              </Button>
              <Button
                key="submit"
                type="primary"
                className="px-4 md:px-14"
                loading={isPending}
                onClick={handleOnSubmitForm}
              >
                บันทึกข้อมูล
              </Button>
            </div>
          </div>
        );
      }}
    >
      <div className="text-center font-semibold">แก้ไขที่อยู่</div>
      <div className="px-4 md:px-28 py-5">
        <Form form={form} className="address-form">
          <Row gutter={[16, 16]}>
            <Col span={7}>ที่อยู่ :</Col>
            <Col span={17}>
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item name="address">
                    <Input
                      className="gray-input-border"
                      placeholder="บ้านเลขที่ / หมู่บ้าน / คอนโด "
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
            <Col span={7} />
            <Col span={17}>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item name="postCode">
                    <InputThaiAddress.Zipcode
                      value={address["zipcode"]}
                      onChange={handleChange("zipcode")}
                      onSelect={handleSelect}
                      autoCompleteProps={{
                        placeholder: "รหัสไปรษณีย์",
                        rootClassName: "address-autocomplete",
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item name="province">
                    <InputThaiAddress.Province
                      value={address["province"]}
                      onChange={handleChange("province")}
                      onSelect={handleSelect}
                      autoCompleteProps={{
                        placeholder: "จังหวัด",
                        rootClassName: "address-autocomplete",
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Col>

            <Col span={7} />
            <Col span={17}>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item name="district">
                    <InputThaiAddress.Amphoe
                      value={address["amphoe"]}
                      onChange={handleChange("amphoe")}
                      onSelect={handleSelect}
                      autoCompleteProps={{
                        placeholder: "อำเภอ / เขต",
                        rootClassName: "address-autocomplete",
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item name="subdistrict">
                    <InputThaiAddress.District
                      value={address["district"]}
                      onChange={handleChange("district")}
                      onSelect={handleSelect}
                      autoCompleteProps={{
                        placeholder: "ตำบล",
                        rootClassName: "address-autocomplete",
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Col>

            <Col span={7}>เบอร์โทร :</Col>
            <Col span={17}>
              <Form.Item name="phoneNumber">
                <Input className="gray-input-border" placeholder="เบอร์โทร" />
              </Form.Item>
            </Col>

            <Col span={7}>LINE ID :</Col>
            <Col span={17}>
              <Form.Item name="lineId">
                <Input className="gray-input-border" placeholder="LINE ID" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </Modal>
  );
};
export default UserDetailModal;
